import React, { useState } from 'react';
import { styleCollective } from './styleService';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import utils from '../../utils/utils';
import { useStateValue } from '../../context/store';

const SearchCollectiveService = ({regionals, laboratorys}) => {
    const classes = styleCollective();
    const [{},dispatch] = useStateValue();
    var currentDate = new Date();
    const [minDate, setMinDate] = useState(null);
    const [maxInitDate, setMaxInitDate] = useState(
        utils.getFormattedDateMMddyyyy(currentDate, ".")
    );

    const schema = yup.object().shape({
        nameLaboratory: yup.string().nullable().notRequired(),
        //regionalId: yup.string().nullable().notRequired(),
        initDate: yup
            .date()
            .typeError("Formato de fecha inválido")
            .when([], {
            is: (initDate) => initDate && initDate.length > 0,
            then: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
            otherwise: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
            }),
        endDate: yup
            .date()
            .typeError("Formato de fecha inválido")
            .when([], {
            is: (endDate) => endDate && endDate.length > 0,
            then: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
            otherwise: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
            }),
    });

    const {register, handleSubmit, control, formState: {errors}, getValues, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValue:{},
        mode: "all",
        reValidateMode: "onChange"
    });

    const onSubmit = (data) => {
        if(
            data.initDate !== null ||
            data.endDate !== null ||
            data.nameLaboratory !== null
        ){
            dispatch({
                type: 'FILTER_COLLECTIVE_SERVICE',
                filter:data,
                isFilter: true
            })
        }
    }

    const clearForm = () => {
        setValue("nameLaboratory", "");
        setValue("initDate", null);
        setValue("endDate", null);
        setMaxInitDate( new Date());
        setMinDate(null);
    }

    const clearBtn = () => {
        clearForm();
        dispatch({
            type: 'FILTER_COLLECTIVE_SERVICE',
            filter:{
                initDate: null,
                endDate: null,
                nameLaboratory: null,
                regionalId: null
            },
            isFilter: true
        })
    };

    const onChangeDate = (value) => {
        setMinDate(value);
    };

    const validateMaxInitDate = () => {
        var currentData = getValues();
        if (!currentData.endDate) {
          setMaxInitDate(utils.getFormattedDateMMddyyyy(currentDate, "."));
        } else {
          setMaxInitDate(utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
        }
    };

    const updateMaxInitDate = (date) => {
        var currentData = getValues();
        if (!currentData.initDate) {
          setMaxInitDate(date);
        } else {
          setMaxInitDate(utils.getFormattedDateMMddyyyy(currentDate, "."));
        }
    };

    return (
        <div className={classes.contFormSearch}>
            <form onSubmit={handleSubmit(onSubmit)} >
                <Grid container spacing={2}>

                    <Grid item xs={12} md={3} lg={3}>
                        <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                            <Controller
                            as={
                                <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                variant="inline"
                                format="dd/MM/yyyy"
                                className = {classes.inputForm}
                                dateFormat="DD/MM/YYYY"
                                label="Desde"
                                InputLabelProps={{ shrink: true }}
                                onAccept={onChangeDate}
                                onOpen={validateMaxInitDate}
                                error={
                                    !!errors.hasOwnProperty("initDate") &&
                                    errors["initDate"].message
                                }
                                helperText={
                                    errors.hasOwnProperty("initDate") &&
                                    errors["initDate"].message
                                }
                                minDate="01.01.2020"
                                //maxDate={maxInitDate}
                                />
                            }
                            control={control}
                            name="initDate"
                            defaultValue={null}
                            placeholder="Desde"
                            size="small"
                            />
                        </MuiPickersUtilsProvider>
                        <FormHelperText style={{ color: "#f44336" }}>

                        </FormHelperText>
                    </Grid>

                    <Grid item xs={12} md={3} lg={3}>
                        <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                            <Controller
                            as={
                                <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                variant="inline"
                                format="dd/MM/yyyy"
                                dateFormat="DD/MM/YYYY"
                                className = {classes.inputForm}
                                label="Hasta"
                                InputLabelProps={{ shrink: true }}
                                onAccept={updateMaxInitDate}
                                error={
                                    !!errors.hasOwnProperty("endDate") &&
                                    errors["endDate"].message
                                }
                                helperText={
                                    errors.hasOwnProperty("endDate") &&
                                    errors["endDate"].message
                                }
                                minDate={minDate ? minDate : "01.01.2020"}
                                //maxDate={maxDate}
                                />
                            }
                            control={control}
                            name="endDate"
                            defaultValue={null}
                            placeholder="Hasta"
                            size="small"
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} md={3} lg={3}>
                        <FormControl
                            variant="outlined"
                            fullWidth
                            size="small"
                            error={!!errors.hasOwnProperty("nameLaboratory") && errors["nameLaboratory"].message}
                        >
                            <InputLabel htmlFor="outlined-select-nameLaboratory" shrink={true}>
                                Nombre de laboratorio
                            </InputLabel>
                            <Controller
                                fullWidth
                                control={control}
                                inputRef={register}
                                className = {classes.inputForm}
                                label="Nombre de laboratorio"
                                name="nameLaboratory"
                                defaultValue=""
                                size="small"
                                notched={true}
                                inputProps={{
                                name: "nameLaboratory",
                                id: "outlined-select-nameLaboratory",
                                }}
                                as={
                                    <Select>
                                        {laboratorys?.map((resp) => (
                                            resp.status === 'Activo'
                                                ?   <MenuItem
                                                        key={resp?.id}
                                                        value={resp?.id}
                                                        className={classes.menuItem}
                                                    >
                                                        {" "}
                                                        {resp?.laboratoryName}{" "}
                                                    </MenuItem>
                                                :   null
                                        ))}
                                    </Select>
                                }
                            />
                            <FormHelperText>
                                {errors.hasOwnProperty("nameLaboratory") &&
                                errors["nameLaboratory"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3} lg={3}>
                        <Button
                            variant="contained"
                            className={classes.buttonSearch}
                            type="submit"
                        >
                            Buscar
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                            variant="contained"
                            className={classes.buttonSearch}
                            onClick={clearBtn}
                        >
                            Limpiar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
  )
}

export default SearchCollectiveService;